module.exports = __webpack_public_path__ + "img/444.8864a1bb.jpg";